export function menuBarStateSelector(ctx) {
  return {
    fontSize: ctx.editor.getAttributes('textStyle').fontSize ?? '',
    isBold: ctx.editor.isActive('bold'),
    isItalic: ctx.editor.isActive('italic'),
    isUnderline: ctx.editor.isActive('underline'),
    isStrike: ctx.editor.isActive('strike'),
    isLink: ctx.editor.isActive('link'),
    isAlignLeft: ctx.editor.isActive({ textAlign: 'left' }),
    isAlignCenter: ctx.editor.isActive({ textAlign: 'center' }),
    isAlignRight: ctx.editor.isActive({ textAlign: 'right' }),
  };
}
